<h1 mat-dialog-title class="regcomplete-title" rtI18n
  [rtI18nParams]="{ name: data.studentFirstName, school: record.SchoolShortName }">[[name]]'s registration is complete at [[school]]!</h1>

<mat-dialog-content class="regcomplete-body">
  <p class="regcomplete-subtitle" rtI18n>Here's what you can do now to get ready for the first day.</p>

  <div class="next-step-cards">
    <div class="next-step-card">
      <div class="card-image image-blue"><i class="icon-form icon-white"></i></div>
      <h3 rtI18n>Complete a few final details</h3>
      <p class="card-description" rtI18n>We've got your paperwork — thank you! Check the link below for any additional forms your family may need, plus a volunteer sign-up if you'd like to get involved.</p>
      <button type="button" class="btn btn-primary" (click)="openAdditionalForms()" rtI18n>View Additional Forms</button>
    </div>

    <div class="next-step-card">
      <div class="card-image image-green"><i class="icon-globe icon-white"></i></div>
      <h3 rtI18n [rtI18nParams]="{ school: record.SchoolShortName }">Visit the [[school]] website</h3>
      <p class="card-description" rtI18n [rtI18nParams]="{ school: record.SchoolShortName }">Prepare for your child's first day of school by visiting the [[school]] website for important information and resources.</p>
      <button type="button" class="btn btn-primary" [disabled]="!websiteUrl" (click)="openWebsite()" rtI18n>Go to the school website</button>
    </div>

    <div class="next-step-card">
      <div class="card-image image-orange"><i class="icon-school icon-white"></i></div>
      <h3 rtI18n [rtI18nParams]="{ school: record.SchoolShortName }">Get a guided tour of [[school]]</h3>
      <p class="card-description" rtI18n [rtI18nParams]="{ school: record.SchoolShortName }">Have you toured [[school]] yet? Schedule a tour of [[school]] today!</p>
      <button type="button" class="btn btn-primary" [disabled]="!tourUrl" (click)="openTour()" rtI18n>Schedule your tour</button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="regcomplete-actions">
  <button type="button" class="btn btn-faded" (click)="close()" rtI18n>Close</button>
</mat-dialog-actions>
